import React, { PureComponent } from "react";
import { Redirect } from "react-router";
import { Link } from "react-router-dom";
import * as myConstClass from "../../constant.js";
import $ from "jquery";
import { toastr } from "react-redux-toastr";
import { Button, Card, CardBody, Label, Row } from "reactstrap";
import { AvForm, AvGroup, AvInput } from "availity-reactstrap-validation";
import { T, Config, TF } from "react-translator-component";
//Config.default = localStorage.getItem("lang");

//const image = myConstClass.SITE_URL + `img/Work-Zone-Pro-logo11.png`;
const image2 = myConstClass.SITE_URL + `img/White.png`;
const image3 = `https://beta.workzoneplus.com/img/logo2.png`;

class LogInForm extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      hrm: "",
      showPassword: false,
      toDashboard: false,
      timeOut: 5000,
      showCloseButton: true,
      progressBar: true,
      position: "top-right",
      complaint_against: [],
      module_array: [],
    };
    this.login = this.login.bind(this);
  }

  onFormSubmit = (e) => {
    // alert();
    //new changes
    e.preventDefault();
    //console.log('this.refs',this.props.history.push('/dashboard_default'));
    const formData = {};
    for (const field in this.refs) {
      formData[field] = this.refs[field].value;
    }
   
    fetch(myConstClass.BASE_URL + `login/verifyLogin/`, {
      method: "POST",
      body: JSON.stringify($("#pform").serializeArray()),
    })
      .then((response) => response.json())
      .then((response) => {
        if (response == 2) {
          toastr.error("Error", "Please enter email..!", this.options);
        } else if (response == 3) {
          toastr.error("Error", "Please enter password ..!", this.options);
        } else if (response == 4) {
          toastr.error("Error", "Login Failed ...!", this.options);
        } else if (response !== false) {
          $(".main").css("background-image", "none");
          $(".main").css("background-size", "none");
          var sarray = response.split("-");
          localStorage.setItem("login_type", sarray["8"]);
          localStorage.setItem("role_modules", sarray["9"]);
          localStorage.setItem("manage_app", sarray["6"]);
          localStorage.setItem("login_id", sarray["7"]);
          localStorage.setItem("package", sarray["4"]);
          localStorage.setItem("manage_promotions", sarray["3"]);
          localStorage.setItem("uname", sarray["2"]);
          localStorage.setItem("utype", sarray["1"]);
          localStorage.setItem("session_id", sarray["0"]);
          localStorage.setItem("company_name", sarray["10"]);
          localStorage.setItem("departementhead", sarray["11"]);
          localStorage.setItem("is_subadmin", sarray["12"]);
          localStorage.setItem("sub_admin_role", sarray["13"]);

          localStorage.setItem("sub_admin_roles", sarray["14"]);

          localStorage.setItem("is_super_user", sarray["15"]);
          localStorage.setItem("hr_admin_roles", sarray["16"]);
          //alert();
          localStorage.setItem("is_google_transaltor", sarray["17"]);
          if (sarray["18"]) {
            localStorage.setItem("lang", sarray["18"]);
          } else {
            localStorage.setItem("lang", "en");
          }

          var is_subadmin = localStorage.getItem("is_subadmin");
          if(is_subadmin=='1')
          {
            localStorage.setItem("on_subadmin_dashboard", "2");
          }
          //localStorage.setItem('is_payroll_privilage', sarray['19']);
          //  alert(sarray['19']);
          localStorage.setItem("org_id_payroll", sarray["20"]);
          if (sarray["19"] != undefined || sarray["19"] != '0') {
           
            var payroll_pri = sarray["19"].split("_");
            localStorage.setItem("is_payroll_privilage", "1");
            localStorage.setItem("empapprovepayroll", payroll_pri["0"]);
            localStorage.setItem("empapprovepaid", payroll_pri["1"]);
            localStorage.setItem("emppayline", payroll_pri["2"]);
          } else {
            
            localStorage.setItem("is_payroll_privilage", "0");
            localStorage.setItem("empapprovepayroll", "0");
            localStorage.setItem("empapprovepaid", "0");
            localStorage.setItem("emppayline", "0");
          }
          localStorage.setItem("is_custom", sarray["22"]);
          localStorage.setItem("is_timmy_machine", sarray["23"]);
          var admin_id = localStorage.getItem("uname");
          var login_id = localStorage.getItem("login_id");

          //	  alert(storedNames);
          var admin_id = localStorage.getItem("uname");
          // alert(admin_id);
          var login_type = localStorage.getItem("login_type");
          var login_id = localStorage.getItem("login_id");
          fetch(
            myConstClass.BASE_URL +
              "user/getunreadMessagesCount/" +
              admin_id +
              "/" +
              login_id +
              "/" +
              login_type
          )
            .then((response) => response.json())
            .then((response) => {
              //const notifications = [];
              //this.setState({leave_types: response})

              //alert(response);
              //alert(response);

              localStorage.setItem("mcount", response);
              //alert(mcount);
              /*    toastr.info(
                                'Message',
                                "You have a new message",
                                this.options
                              ) */
            })
            .catch((err) => console.log(err));

          fetch(
            myConstClass.BASE_URL +
              "user/getunreadOrderCount/" +
              admin_id +
              "/" +
              login_type
          )
            .then((response) => response.json())
            .then((response) => {
              //const notifications = [];
              //this.setState({leave_types: response})

              //alert(response);
              //alert(response);

              localStorage.setItem("ocount", response);
              //alert(mcount);
              /*    toastr.info(
                                'Message',
                                "You have a new message",
                                this.options
                              ) */
            })
            .catch((err) => console.log(err));

          // alert(mcount);
          // alert(mcount);

          this.setState(() => ({
            toDashboard: true,
          }));
        }
      })
      .catch();
  };
  componentDidMount() {
    // localStorage.setItem('forget', '0');
    // window.location.href = '/';
    
    // encodeURIComponent(myUrl)
    // alert("hii");
    const answer_array = window.location.href.split('?');
    //alert(answer_array[2]);alert(answer_array[3]);
    if(answer_array[1]=='1')
    {
      localStorage.setItem("email", answer_array[2]);
      localStorage.setItem("password", answer_array[3]);
      localStorage.setItem("common_login", '1');
      this.login(this);
    }
    else{
      localStorage.setItem("common_login", '0');
    }
    var admin_id = localStorage.getItem("uname");
    $(".main").css(
      "background-image",
      "url(https://www.workzoneplus.com/crm1/files/system/system_file64229531b8679-Workzone-CRM.jpeg)"
    );
    $(".main").css("background-size", "cover");
    var w = 100;
    var h = 100;

    // $(".h-100").css("background-size", w+"% " + h + "% ");

    // if(admin_id != null)
    // {
    //   localStorage.clear();
    // }
    fetch(myConstClass.BASE_URL + "login/get_hrm/" + window.location.href)
      .then((response) => response.json())
      .then((response) => {
        this.setState({ hrm: response });
      })
      .catch((err) => console.log(err));
  }
  logine(e) {
    // alert('signup');
    // e.preventDefault();
    //this.props.history.push('/signup');
    localStorage.setItem("signup", "1");
    window.location.href = "/signup";
  }
  show_qrcode(e) {
    // alert('signup');
    // e.preventDefault();
    //this.props.history.push('/signup');
    localStorage.setItem("scan", "1");
    window.location.href = "/Organizationqrcode";
  }
show_leave(e) {
    // alert('signup');
    // e.preventDefault();
    //this.props.history.push('/signup');
    localStorage.setItem("leave", "1");
    window.location.href = "/applyLeave";
  }
 
   show_ot(e) {
    // alert('signup');
    // e.preventDefault();
    //this.props.history.push('/signup');
    localStorage.setItem("ot", "1");
    window.location.href = "/applyOt";
  }  
  forget_password(e) {
    // alert('signup');
    // e.preventDefault();
    //this.props.history.push('/signup');
    localStorage.setItem("forget", "1");
    window.location.href = "/reset-password";
  }

  login(e) {
    if (e && e.preventDefault) e.preventDefault();
    // Guard against double clicks / double-fires triggering two login requests
    if (this._loggingIn) return;
    this._loggingIn = true;
    //localStorage.setItem("common_login", '1');
    //console.log('this.refs',this.props.history.push('/dashboard_default'));
    const formData = {};
    for (const field in this.refs) {
      formData[field] = this.refs[field].value;
    }
    console.log("-->", formData);
    var common_login = localStorage.getItem("common_login");
    const datay=JSON.stringify($("#pform").serializeArray());
    const data = {
      email: localStorage.getItem("email"),
      password: localStorage.getItem("password"),
      common:1,
    };
    fetch(myConstClass.LOGIN_URL + `/login/auth/`, {
      method: "POST",
      body:common_login=='1'?JSON.stringify(data):datay,
      //body:datay,
    })
      .then((response) => response.json())
      .then((response) => {
        if (response == 2) {
          this._loggingIn = false;
          toastr.error(
            TF("{0}", T("Error")),
            TF("{0} {1} {2}...!", T("Please"), T("enter"), T("Email ID")),
            this.options
          );
        } else if (response == 3) {
          this._loggingIn = false;
          toastr.error(
            TF("{0}", T("Error")),
            TF("{0} {1} {2}...!", T("Please"), T("enter"), T("password")),
            this.options
          );
        } else if (response == 4) {
          this._loggingIn = false;
          toastr.error(
            TF("{0}", T("Error")),
            TF("{0} {1}...!", T("Incorrect"), T("Credentials")),
            this.options
          );
        } else if (response == 5) {
          this._loggingIn = false;
          toastr.error(
            TF("{0}", T("Error")),
            TF("{0} {1}...!", T("Incorrect"), T("Password")),
            this.options
          );
        } else if (response == 6) {
          this._loggingIn = false;
          toastr.error(
            TF("{0}", T("Error")),
            TF("{0} {1}...!", T("Incorrect"), T("Email ID")),
            this.options
          );
        } else if (response == 7) {
          this._loggingIn = false;
          toastr.error(
            TF("{0}", T("Error")),
            TF("{0} {1}...!", T("Login"), T("Unsuccessful")),
            this.options
          );
        } else if (response !== false) {
          var sarray = response.split("-");

          // alert(sarray['2']);
          //  alert(sarray['2']);
          //alert(sarray['8']);alert(sarray['7']);
          localStorage.setItem("signup", "0");
          localStorage.setItem("login_type", sarray["8"]);
          localStorage.setItem("role_modules", sarray["9"]);
          localStorage.setItem("login_id", sarray["7"]);
          localStorage.setItem("manage_app", sarray["6"]);
          localStorage.setItem("url", sarray["5"]);
          localStorage.setItem("package", sarray["4"]);
          localStorage.setItem("manage_promotions", sarray["3"]);
          localStorage.setItem("uname", sarray["2"]);
          localStorage.setItem("utype", sarray["1"]);
          localStorage.setItem("session_id", sarray["0"]);
          localStorage.setItem("company_name", sarray["10"]);
          localStorage.setItem("departementhead", sarray["11"]);
          localStorage.setItem("is_subadmin", sarray["12"]);
          localStorage.setItem("sub_admin_role", sarray["13"]);

          localStorage.setItem("sub_admin_roles", sarray["14"]);
          localStorage.setItem("is_super_user", sarray["15"]);
          localStorage.setItem("hr_admin_roles", sarray["16"]);
          //alert(sarray['19']);
          localStorage.setItem("is_google_transaltor", sarray["17"]);
          if (sarray["18"]) {
            localStorage.setItem("lang", sarray["18"]);
          } else {
            localStorage.setItem("lang", "en");
          }

          var is_subadmin = localStorage.getItem("is_subadmin");
          if(is_subadmin=='1')
          {
            localStorage.setItem("on_subadmin_dashboard", "2");
          }
          //alert(sarray['18']);
          // localStorage.setItem('is_payroll_privilage', sarray['19']);
          //alert(sarray['19']);
          localStorage.setItem("org_id_payroll", sarray["20"]);

          if (sarray["19"] !== undefined && sarray["19"] !== '0') {
             //alert('hii');
            var payroll_pri = sarray["19"].split("_");
            var is_sub_admin_with_payroll = localStorage.setItem(
              "is_sub_admin_with_payroll",1
            );
            localStorage.setItem("is_payroll_privilage", "1");
            localStorage.setItem("empapprovepayroll", payroll_pri["0"]);
            localStorage.setItem("empapprovepaid", payroll_pri["1"]);
            localStorage.setItem("emppayline", payroll_pri["2"]);
          } else {
            var is_sub_admin_with_payroll = localStorage.setItem(
              "is_sub_admin_with_payroll",2
            );
            localStorage.setItem("is_payroll_privilage", "0");
            localStorage.setItem("empapprovepayroll", "0");
            localStorage.setItem("empapprovepaid", "0");
            localStorage.setItem("emppayline", "0");
          }
          localStorage.setItem("is_custom", sarray["22"]);
          localStorage.setItem("is_timmy_machine", sarray["23"]);
          // alert(sarray['20']);
          //alert(localStorage.getItem('emppayline'));
          Config.default = localStorage.getItem("lang");
          if (sarray["15"] == "1") {
            if (sarray["16"] != "0") {
              const myArraymodules = sarray["16"].split(",");
              if (myArraymodules != undefined) {
                if (myArraymodules[0] == "1") {
                  localStorage.setItem("admin_settings", true);
                } else {
                  localStorage.setItem("admin_settings", false);
                }

                if (myArraymodules[1] == "1") {
                  localStorage.setItem("admin_hradmin", true);
                } else {
                  localStorage.setItem("admin_hradmin", false);
                }

                if (myArraymodules[2] == "1") {
                  localStorage.setItem("admin_promotions", true);
                } else {
                  localStorage.setItem("admin_promotions", false);
                }

                if (myArraymodules[3] == "1") {
                  localStorage.setItem("admin_adminstaff", true);
                } else {
                  localStorage.setItem("admin_adminstaff", false);
                }
                
                if (myArraymodules[4] == "1") {
                  localStorage.setItem("admin_logs", true);
                } else {
                  localStorage.setItem("admin_logs", false);
                }


                if (myArraymodules[5] == "1") {
                  localStorage.setItem("signuprequest", true);
                } else {
                  localStorage.setItem("signuprequest", false);
                }

              }
            }
          } else {
            if (sarray["16"] != "0") {
              const myArraymodules = sarray["16"].split(",");
              if (myArraymodules != undefined) {
                //alert(myArraymodules);
                if (myArraymodules[0] == "1") {
                  localStorage.setItem("hr_work_plan", true);
                } else {
                  localStorage.setItem("hr_work_plan", false);
                }

                if (myArraymodules[1] == "1") {
                  localStorage.setItem("hr_emp_careeer", true);
                } else {
                  localStorage.setItem("hr_emp_careeer", false);
                }

                if (myArraymodules[2] == "1") {
                  localStorage.setItem("hr_emp_training", true);
                } else {
                  localStorage.setItem("hr_emp_training", false);
                }

                if (myArraymodules[3] == "1") {
                  localStorage.setItem("hr_emp_msg", true);
                } else {
                  localStorage.setItem("hr_emp_msg", false);
                }

                if (myArraymodules[4] == "1") {
                  localStorage.setItem("hr_emp_shop", true);
                } else {
                  localStorage.setItem("hr_emp_shop", false);
                }

                if (myArraymodules[5] == "1") {
                  localStorage.setItem("hr_emp_promotions", true);
                } else {
                  localStorage.setItem("hr_emp_promotions", false);
                }

                if (myArraymodules[6] == "1") {
                  localStorage.setItem("hr_emp_annoucements", true);
                } else {
                  localStorage.setItem("hr_emp_annoucements", false);
                }

                if (myArraymodules[7] == "1") {
                  localStorage.setItem("hr_emp_blogs", true);
                } else {
                  localStorage.setItem("hr_emp_blogs", false);
                }

                if (myArraymodules[8] == "1") {
                  localStorage.setItem("hr_emp_guests", true);
                } else {
                  localStorage.setItem("hr_emp_guests", false);
                }

                if (myArraymodules[9] == "1") {
                  localStorage.setItem("hr_emp_evalution", true);
                } else {
                  localStorage.setItem("hr_emp_evalution", false);
                }

                if (myArraymodules[10] == "1") {
                  localStorage.setItem("hr_emp_reports", true);
                } else {
                  localStorage.setItem("hr_emp_reports", false);
                }

                if (myArraymodules[11] == "1") {
                  localStorage.setItem("hr_emp_activity", true);
                } else {
                  localStorage.setItem("hr_emp_activity", false);
                }

                if (myArraymodules[12] == "1") {
                  localStorage.setItem("hr_emp_issue", true);
                } else {
                  localStorage.setItem("hr_emp_issue", false);
                }

                if (myArraymodules[13] == "1") {
                  localStorage.setItem("hr_blogs", true);
                } else {
                  localStorage.setItem("hr_blogs", false);
                }

                if (myArraymodules[14] == "1") {
                  localStorage.setItem("hr_letter", true);
                } else {
                  localStorage.setItem("hr_letter", false);
                }

                if (myArraymodules[15] == "1") {
                  localStorage.setItem("hr_group", true);
                } else {
                  localStorage.setItem("hr_group", false);
                }




                // localStorage.setItem('org_id_payroll', sarray['20']);
                if (sarray["21"] == "1") {
                  localStorage.setItem("hr_emp_biomatrics", true);
                } else {
                  localStorage.setItem("hr_emp_biomatrics", false);
                }

                window.location.reload(false);
              }
            }
          }

          // fetch(myConstClass.BASE_URL+'organization/getmodulesAgainstInfo/'+sarray['13'])
          // .then(response => response.json())
          // .then(response =>{
          //   let i=1;
          // //  alert(response);
          //   localStorage.setItem("modulenames",response);
          // this.setState({module_array: response})}).catch(err => console.log(err));
          // // localstorage.modulenames = JSON.stringify(module_array);
          // var storedmoduleNames = JSON.parse(localStorage.modulenames);

          //...
          // var storedNames = JSON.parse(localStorage.getItem("modulenames"));

          //alert(storedNames);

          this.setState(() => ({
            toDashboard: true,
          }));

          var admin_id = localStorage.getItem("uname");
        } else {
          this._loggingIn = false;
          toastr.error(
            TF("{0}", T("Error")),
            TF("{0} {1}...!", T("Login"), T("Unsuccessful")),
            this.options
          );
        }
      })
      .catch((err) => {
        this._loggingIn = false;
        console.log(err);
      });
  }

  render() {
    // var url = window.location.href;
    // var str = url.split("/");
    // let ten_path;
    // let file_ten_path;
    // if(str[4] != '' && str[3] != ''){
    // ten_path = str[3]+'/'+ str[4];
    // file_ten_path  =  "/"+ten_path+'/dashboard';
    // } else {
    // ten_path = '';
    // file_ten_path='/dashboard';
    // }

    let file_ten_path;
    let path1;
    let path2;
    let path3;
    let path4;
    // let url;

    var tenant_url = localStorage.getItem("url");
    var login_type = localStorage.getItem("login_type"); //alert(login_type);
    var joburl = localStorage.getItem("joburl");
    var joburlcomp = localStorage.getItem("joburlcomp");
    var is_timmy_machine = localStorage.getItem("is_timmy_machine");
   // alert(joburl);
    var admin_id = localStorage.getItem("uname");

    if (window.localStorage) {
      if (!localStorage.getItem("firstLoad")) {
        localStorage["firstLoad"] = true;
        window.location.reload();
      } else localStorage.removeItem("firstLoad");
    }

    if (tenant_url) {
      if (login_type == "emp") {
        if (joburl == "1" && is_timmy_machine==0) {
          file_ten_path = myConstClass.CARREERCOMPANY_URL+ joburlcomp;
        } else if (parseInt(is_timmy_machine) === 0)
        {
          file_ten_path = tenant_url + "attendance/checkinout";
        }
        else{
          file_ten_path = tenant_url + "employees/profileinfo";
        }
      } else if (login_type == "security") {
        //alert('hii');
        //	file_ten_path =tenant_url+"guests/listing";
        var hr_emp_guests = localStorage.getItem("hr_emp_guests");
        if (hr_emp_guests == "true") {
          file_ten_path = "/" + tenant_url + "guests/listing";
        } else {
          file_ten_path =
            "/" + tenant_url + "attendance/ListingCheckoutSecurity";
        }
      } else {
        file_ten_path = tenant_url + "dashboard";
      }
    } else {
      var url = window.location.pathname;
      var str = url.split("/");
      if (str[1] == "t") {
        if (str[1] && str[1] != "undefined") {
          path1 = str[1] + "/";
        }
        if (str[2] && str[2] != "undefined" && str[2] != "t") {
          path2 = str[2] + "/";
        }
        if (str[3] && str[3] != "undefined") {
          path3 = str[3];
        } else {
          path3 = "";
        }

        // alert("A- "+path1+'  '+path2+'  '+path3);
        file_ten_path = path2 + path3 + "dashboard";
      } else {
        if (str[1] && str[1] != "undefined") {
          path1 = str[1] + "/";
        }

        if (str[2] && str[2] != "undefined") {
          path2 = str[2];
        } else {
          path2 = "index.php";
        }

        if (str[3] && str[3] != "undefined") {
          path3 = str[3] + "/";
        } else {
          path3 = "";
        }

        if (str[4] && str[4] != "undefined") {
          path4 = str[4] + "/";
        } else {
          path4 = "";
        }

        file_ten_path = path1 + path2 + "/" + path3 + path4 + "dashboard";
      }
    }

    //////////////////

    // if(str[1] && str[1] != 'undefined' &&  str[2] && str[2] != 'undefined' ){
    //   ten_path = str[1]+'/'+ str[2];
    //   file_ten_path  = "/"+ten_path ;
    //   dashboardR = "/"+ten_path+"/dashboard";
    // } else if(str[1] && str[1] != 'undefined'){
    //   ten_path = str[1];
    //   file_ten_path  = "/"+ten_path ;
    //   dashboardR = "/"+ten_path+"/dashboard";
    // }

    if (this.state.toDashboard === true) {
      window.location.href = file_ten_path;
      return <Redirect to="/dashboard" />;
    }
    const { hrm } = this.state;

    return (
      <React.Fragment>
        <div className="text-center mt-4"></div>
        <Card>
          <CardBody>
            <div className="m-sm-4">
              <div className="text-center">
                {/* <img src={image2} style={{'width':'40px','height':'40px'}}></img> */}
                <img
                  src={image2}
                  style={{ width: "100px", height: "100px;" }}
                  hspace={20}
                ></img>
                {/* <img
                  src={image}
                  style={{ width: "300px", height: "38px;" }}
                ></img> */}
              </div>
              {/* <br /> */}
              <br />
              <div className="text-center">
                <h3>Login</h3>
              </div>
              {/* <br /> */}
              <br />
              <AvForm className="form" id="pform" onSubmit={this.onFormSubmit}>
                <AvGroup>
                  <Label for="example">{T("Email ID")}</Label>
                  <span style={{ color: "red", fontSize: "15px" }}> *</span>
                  <AvInput
                    name="email"
                    type="email"
                    placeholder="Enter your email"
                    value={hrm ? hrm.email : ""}
                  />
                </AvGroup>
                <AvGroup>
                  <Label for="example">{T("Password")}</Label>
                  <span style={{ color: "red", fontSize: "15px" }}> *</span>
                  <AvInput
                    name="password"
                    type="password"
                    placeholder="Enter your password"
                    value={hrm ? hrm.password : ""}
                  />
                </AvGroup>
                <small>
                  <Link
                    //to="/auth/reset-password"
                    onClick={this.show_qrcode}
                  >
                    Show Qrcode
                  </Link>
                </small>
                   &nbsp;&nbsp;
                 <small>
                  <Link
                    //to="/auth/reset-password"
                    onClick={this.show_leave}
                  >
                   Apply Leave 
                  </Link>
                </small>
                &nbsp;&nbsp;
                 <small>
                  <Link
                    //to="/auth/reset-password"
                    onClick={this.show_ot}
                  >
                    Apply OT
                  </Link>
                </small>
              &nbsp;&nbsp;
                <small>
                  <Link
                    //to="/auth/reset-password"
                    onClick={this.forget_password}
                  >
                    Forgot password?
                  </Link>
                </small>
                <center>
                  {" "}
                  <div>
                    Don't have an account ?{" "}
                    <a
                      //href="/signup"
                      style={{
                        textDecoration: "underline",
                        color: "#3B7DDD",
                        cursor: "pointer",
                      }}
                      onClick={this.logine}
                    >
                      {T(" Sign Up Now")}
                    </a>
                  </div>
                </center>
                <div className="text-center mt-3">
                  <Button
                    color="primary"
                    type="button"
                    autofocus="autofocus"
                    onClick={this.login}
                  >
                    Sign in
                  </Button>
                </div>
                <br />
                <Row></Row>
                <Row>
                  <div class="col-md-2">
                    {/* <a target="_blank"  href="https://play.google.com/store/apps/details?id=com.easyhrm4u.freeAttendanceApp&hl=en_IN"><img src= "http://localhost/workzone/workzone/backend/uploads/play_store.png"  /></a> */}
                    {/* <img src="%PUBLIC_URL%/play_store.png" />
            For Android App <a href="https://play.google.com/store/apps/details?id=com.easyhrm4u.freeAttendanceApp&hl=en_IN" target="_blank" >Click Here</a> */}
                  </div>
                  <div class="col-md-8">
                    {/* <a t82-
          ']rget="_blank"  href="https://play.google.com/store/apps/details?id=com.easyhrm4u.freeAttendanceApp&hl=en_IN"><img src= "http://localhost/workzone/workzone/backend/uploads/App Links/play_store.png"  /></a>
           <a target="_blank"  href="https://apps.apple.com/in/app/workzoneplus-time-attendance/id1484059797"><img src= "http://localhost/workzone/workzone/backend/uploads/App Links/app_store.png"  /></a>
           */}
                    <a
                      target="_blank"
                      href="https://play.google.com/store/apps/details?id=com.easyhrm4u.freeAttendanceApp&hl=en_IN"
                    >
                      <img src="https://beta.workzoneplus.com/backend/uploads/App Links/play_store.png" />
                    </a>
                    <a
                      target="_blank"
                      href="https://apps.apple.com/in/app/workzoneplus-time-attendance/id1484059797"
                    >
                      <img src="https://beta.workzoneplus.com/backend/uploads/App Links/app_store.png" />
                    </a>
                  </div>
                  <div class="col-md-2">
                    {/* <a target="_blank"  href="https://apps.apple.com/in/app/workzoneplus-time-attendance/id1484059797"><img src= "http://localhost/workzone/workzone/backend/uploads/app_store_new.png"  /></a> */}
                    {/* For iOS App <a href="https://apps.apple.com/in/app/workzoneplus-time-attendance/id1484059797" target="_blank" >Click Here</a> */}
                  </div>
                </Row>
              </AvForm>
            </div>
          </CardBody>
        </Card>
        <center>
          <img src={image3} style={{ width: "35%" }}></img>
          <br />
          <p>
            <a href="https://www.epenh.com" target="_blank">
              Developed by Epenh Co. Ltd © 2019
            </a>
          </p>
        </center>
      </React.Fragment>
    );
  }
}

export default LogInForm;